const boxShadow = {
  card: '0 3px 12px rgba(49,60,70,0.2), 0 2px 4px rgba(49,60,70,0.15)',
  cardHover: '0 6px 24px rgba(49,60,70,0.3), 0 3px 6px rgba(49,60,70,0.2)',
}

export default boxShadow
